import { Directive, HostListener, inject, input, output } from '@angular/core';
import { GuestAuthService } from '../services';

@Directive({
  selector: '[olGuestPopup]',
})
export class GuestPopupDirective {
  filmId = input<string>('');
  postId = input<string>('');
  isGuest = input<boolean>(false);

  openGuestView = output<void>();

  #guestAuthService = inject(GuestAuthService);

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.stopPropagation();

    if (!this.isGuest()) {
      return;
    }

    this.#guestAuthService.handleGuestAuth({
      filmId: this.filmId(),
      postId: this.postId(),
      onCommunityInApp: () => this.openGuestView.emit(),
    });
  }
}
